import { z } from "zod";

export const assignCompanySchema = z.object({
  company_ids: z.array(z.number()),
});

export type AssignCompany = z.infer<typeof assignCompanySchema>;
